import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Group, Contact } from '../model';
import { TextImportComponent } from '../component/contacts-manager/text-import/text-import.component';
import { VcardImportComponent } from '../component/contacts-manager/vcard-import/vcard-import.component';

@Injectable()
export class ContactImportService {
  loadingRef: any;

  constructor(public dialog: MatDialog) {}

  quickImport(otherContacts?: Contact[]): Observable<string[]> {
    const dialogRef = this.dialog.open(TextImportComponent, {
      width: '420px'
    });

    otherContacts = otherContacts ? otherContacts : [];
    dialogRef.componentInstance.contacts = otherContacts;
    return dialogRef.afterClosed();
  }

  groupImport(groups: Group[]): Observable<Contact[]> {
    const dialogRef = this.dialog.open(TextImportComponent, {
      width: '420px'
    });

    dialogRef.componentInstance.groups = groups;
    return dialogRef.afterClosed();
  }

  vCardImport(groups: Group[]): Observable<Contact[]> {
    const dialogRef = this.dialog.open(VcardImportComponent, {
      width: '420px'
    });

    dialogRef.componentInstance.groups = groups;
    return dialogRef.afterClosed();
  }

}
